import styled from "styled-components";
import { colors } from "../../../../../../../theme/theme";
import { Button } from "react-bootstrap";

export const SelectInfoStyled = styled.div`
    background: ${colors.mainColors.white_lilac};
    width: 100%;
    border-radius: 4px;
    text-align: center;
    padding: 9px 0px;
`

export const SelectButton = styled(Button)`
    padding: 0;

    font-weight: 400;
    font-size: 14px;
    line-height: 30px;

    color: ${colors.mainColors.indigo};
    vertical-align: unset;
    text-decoration: none;
    margin-left: 2px;
`